// Querys and Mutations
import {
  ALL_ACTIVE,
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE
} from '@/graphql/config/InsuranceCompanyGraphql'

// models
import { ResponseDefault, Paginator } from '@/models'
import { InsuranceCompany, InsuranceCompanyForm, InsuranceCompanyWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class InsuranceCompanyService {
    /**
    * Queries
    */
    async getActivated (): Promise<InsuranceCompany[]> {
      const result = await apolloClient.query({
        query: ALL_ACTIVE
      })
      return result.data.insuranceCompaniesActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<InsuranceCompanyWithPagination> {
      const result = await apolloClient.query({
        query: GET_WITH_PAGINATION,
        variables: {
          page: page,
          perPage: perPage
        }
      })
      const pagination: Paginator = result.data.insuranceCompaniesWithPagination.paginatorInfo
      const data: InsuranceCompany[] = result.data.insuranceCompaniesWithPagination.data
      const response: InsuranceCompanyWithPagination = {
        objects: data,
        pagination: pagination
      }
      return response
    }

    /**
    * Mutations
    */
    async create (form: InsuranceCompanyForm): Promise<InsuranceCompany> {
      const result = await apolloClient.mutate({
        mutation: CREATE,
        variables: {
          input: form
        }
      })
      return result.data.createInsuranceCompany
    }

    async update (id: number, form: InsuranceCompanyForm): Promise<InsuranceCompany> {
      const result = await apolloClient.mutate({
        mutation: UPDATE,
        variables: {
          id: id,
          input: form
        }
      })
      return result.data.updateInsuranceCompany
    }

    async delete (id: number): Promise<ResponseDefault> {
      await apolloClient.mutate({
        mutation: DELETE,
        variables: {
          id: id
        }
      })
      return {
        success: true,
        errors: []
      }
    }
}

export default new InsuranceCompanyService()
